import { render } from "./SettingsTeamView.vue?vue&type=template&id=5ab14958"
import script from "./SettingsTeamView.vue?vue&type=script&lang=js"
export * from "./SettingsTeamView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SettingsTeamView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ab14958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ab14958', __exports__)) {
    api.reload('5ab14958', __exports__)
  }
  
  module.hot.accept("./SettingsTeamView.vue?vue&type=template&id=5ab14958", () => {
    api.rerender('5ab14958', render)
  })

}


export default __exports__